import { FAQ } from 'shared/constants/faq';
import { Title } from '../Title';
import * as style from './Faq.css';
import { FaqItem } from '../FaqItem';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

export const Faq: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(style['container'], device === 'phone' && style['container-phone'])}>
      <div className={style['title']}>
        <Title>Вопросы и ответы</Title>
      </div>
      <div className={style['list']}>
        {FAQ.map(item => (
          <FaqItem key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};
